export class ResizeObserverStub {
  public disconnect(): void {}
  public observe(target: Element, options?: ResizeObserverOptions): void {}
  public unobserve(target: Element): void {}
}
